export default __webpack_public_path__ + "static/media/greenctg.e014c257.jpg";